<template>
  <div>
    <div ref="hereMap" id="hereMap" class="here-map__container"></div>
    <v-container>
      <v-row>
        <v-col align-self="end">
          <v-dialog
            v-model="sheet"
            :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
            persistent
          >
            <v-card class="rounded-lg cardColor">
              <v-card-text>
                <p
                  class="text-center my-3 text-subtitle-2 text-sm-subtitle-1 text-md-subtitle-1 text-lg-subtitle-1 text-xl-subtitle-1"
                >
                  {{ translations.label_subsample_photos }}
                </p>
                <v-carousel
                  hide-delimiter-background
                  :show-arrows="true"
                  height="auto"
                  class="mt-0"
                  v-model="navigation"
                >
                  <v-carousel-item v-for="(item, i) in urls" :key="i">
                    <v-img
                      v-if="
                        item.img && item.img != '' && item.img.includes('http')
                      "
                      :src="item.img"
                      contain
                    >
                      <v-row class="button-container">
                        <v-btn
                          v-if="item.description.length > 0"
                          @click="openDialog(item.description)"
                          color="green"
                          small
                          fab
                          class="mt-10 button-item"
                        >
                          <v-icon color="white">mdi-information-outline</v-icon>
                        </v-btn>
                        <v-btn
                          v-if="item.symptoms && item.symptoms.length > 0"
                          @click="openDialog(item.symptoms)"
                          color="green"
                          small
                          fab
                          class="mt-10 button-item"
                        >
                          <v-icon color="white">mdi-bug</v-icon>
                        </v-btn>
                        <v-btn
                          v-if="item.kind && item.kind.length > 0"
                          @click="openDialog(item)"
                          color="orange"
                          small
                          fab
                          class="mt-10 button-item"
                        >
                          <v-icon color="white">mdi-bug</v-icon>
                        </v-btn>
                        <v-btn
                          @click="downloadImg(item.img)"
                          color="green"
                          small
                          fab
                          class="mt-10 button-item"
                          :loading="isLoading"
                        >
                          <v-icon color="white">mdi-download</v-icon>
                        </v-btn>
                      </v-row>
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-img
                      v-else
                      :src="require('@/assets/img/no_image_icon.png')"
                      contain
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-carousel-item>
                </v-carousel>
              </v-card-text>
              <v-card-actions>
                <!-- <v-row>
                  <v-col> -->
                <v-btn
                  color="green"
                  @click="closeSheet"
                  block
                  dark
                  class="mb-1"
                >
                  {{ translations.label_close }}
                </v-btn>
                <!-- </v-col>
                </v-row> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <span class="text-h6 lighten-2">{{
                    description.kind && description.kind.length > 0
                      ? getKind(description.kind)
                      : translations.label_sample_description
                  }}</span>
                  <v-spacer></v-spacer>
                  {{
                    description.kind && description.kind.length > 0
                      ? getIssue(description.kind, description.issue)
                      : description
                  }}
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="openDialog">
              {{ translations.accept }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {
  props: {
    sample: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    isLoading: false,
    dialog: false,
    description: "",
    navigation: null,
    urls: [],
    sheet: false,
    map: {},
    platform: {},
    loading: false,
    apikey: process.env.VUE_APP_HERE_APIKEY,
    center: {
      lat: 0,
      lng: 0,
    },
    zoom: 17,
    markerSubSamples: [],
    map_icon: {},
    markerIcon: {
      imgFlag:
        '<svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 492 496" width="99" height="100"><title>solena-flag</title><defs><image  width="456" height="469" id="img1" href="data:image/png;base64,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"/></defs><style>tspan { white-space:pre }</style><use id="Background" href="#img1" x="21" y="13" /></svg>',
      imgX:
        '<svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="400" height="400" viewBox="0, 0, 400,400"><g id="svgg"><path id="path0" d="M34.754 34.754 C 16.069 53.440,0.781 69.284,0.781 69.963 C 0.781 70.643,29.608 100.030,64.841 135.267 L 128.900 199.336 124.167 204.623 C 121.564 207.531,117.786 211.178,115.771 212.727 C 113.757 214.277,90.010 237.799,62.999 264.999 C -1.947 330.400,0.781 327.573,0.781 329.484 C 0.781 331.384,68.121 399.219,70.007 399.219 C 70.633 399.219,91.173 379.268,115.654 354.883 C 140.134 330.498,160.162 310.685,160.160 310.853 C 160.158 311.021,164.003 307.356,168.705 302.709 C 173.406 298.061,177.185 293.881,177.103 293.418 C 177.021 292.956,177.345 292.650,177.823 292.738 C 178.302 292.826,183.349 288.168,189.040 282.386 C 194.731 276.605,199.745 271.875,200.183 271.875 C 200.620 271.875,207.503 278.467,215.478 286.523 C 223.453 294.580,231.035 301.963,232.328 302.930 C 233.621 303.896,234.352 304.687,233.954 304.688 C 233.555 304.688,237.260 308.730,242.187 313.672 C 247.115 318.613,251.472 322.656,251.870 322.656 C 252.268 322.656,269.693 339.883,290.593 360.937 C 311.494 381.992,329.196 399.219,329.933 399.219 C 332.013 399.219,399.219 331.652,399.219 329.560 C 399.219 328.375,393.841 322.422,381.740 310.213 C 355.049 283.283,308.328 236.596,292.250 220.789 C 284.335 213.007,276.333 205.018,274.468 203.035 L 271.078 199.430 335.148 135.349 C 370.387 100.105,399.219 70.725,399.219 70.060 C 399.219 69.029,352.962 22.069,336.173 6.055 C 328.865 -0.916,330.114 -1.461,311.777 16.706 C 290.204 38.078,214.687 113.603,206.814 121.680 C 203.359 125.225,200.295 128.125,200.006 128.125 C 199.718 128.125,191.733 120.303,182.264 110.742 C 160.544 88.814,112.857 41.124,89.787 18.260 C 77.578 6.159,71.625 0.781,70.440 0.781 C 69.225 0.781,58.858 10.651,34.754 34.754 M227.002 297.070 L 229.297 299.609 226.758 297.315 C 224.391 295.176,223.860 294.531,224.463 294.531 C 224.598 294.531,225.740 295.674,227.002 297.070 " stroke="none" fill="#fb8c00" fill-rule="evenodd"></path></g></svg>',
    },
    groupMarkers: {},
  }),
  created() {
    if (
      this.sample.status != "NOT_STARTED" &&
      this.sample.status != "IN_PROGRESS"
    ) {
      if (this.sample.samplePhotos.length > 0) {
        this.urls.push({
          img: this.sample.samplePhotos[0].photo,
          description: "",
        });
      }
    }

    let imgs = this.sample.subSamples;

    imgs.forEach((item) => {
      var label =
        typeof item.description === "undefined" ? "" : item.description;
      let symptoms = "";
      item.symptoms.forEach((symptom, index) => {
        if (index == item.symptoms.length - 1) {
          symptoms += `${this.getSymptomatology(symptom)}.`;
        } else {
          symptoms += `${this.getSymptomatology(symptom)}, `;
        }
      });

      this.urls.push({
        img: item.subSamplePhoto,
        description: label,
        symptoms: symptoms,
        kind: item.kind,
        issue: item.issue,
      });
    });

    if (this.sample.soilArea.location) {
      this.center = {
        lat: this.sample.soilArea.location.lat,
        lng: this.sample.soilArea.location.lng,
      };
    } else {
      this.center = {
        lat: 49.259149,
        lng: -123.008555,
      };
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions("samples", ["getImg"]),
    ...mapMutations("samples", ["SET_SHOW_ALL"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    initialize() {
      this.platform = new window.H.service.Platform({
        apikey: this.apikey,
      });

      const mapContainer = this.$refs.hereMap;
      let defaultLayers = this.platform.createDefaultLayers({
        engineType: H.Map.EngineType.HARP,
        tileSize: devicePixelRatio > 1 ? 512 : 256,
        ppi: devicePixelRatio > 1 ? 320 : 72,
      });

      //  initialize a map
      this.map = new H.Map(mapContainer, defaultLayers.raster.satellite.map, {
        center: { lat: 52.51604, lng: 13.37691 },
        zoom: 15,
        engineType: H.Map.EngineType.HARP,
        pixelRatio: window.devicePixelRatio || 1,
        tileSize: 512,
      });

      // add a resize listener to make sure that the map occupies the whole container
      window.addEventListener("resize", () => this.map.getViewPort().resize());

      // implements default interactions for pan/zoom
      let behavior = new H.mapevents.Behavior(
        new H.mapevents.MapEvents(this.map)
      );

      // let copyright = document.getElementsByClassName("H_copyright");
      // copyright[0].replaceChildren();

      if (this.sample.soilArea.location) {
        this.addPolygonToMap();
      }
    },
    addPolygonToMap() {
      let statusColor = {
        NOT_ASSIGNED: "rgba(193, 193, 193, 0.7)",
        NOT_STARTED: "rgba(90, 190, 240, 0.7)",
        COMPLETED: "rgba(0, 128, 0, 0.7)",
        IN_PROGRESS: "rgba(241, 216, 89, 0.7)",
        INACCESSIBLE: "rgba(237, 42, 45, 0.7)",
        LAYOUT: "rgba(244, 159, 119, 0.7)",
      };
      let objects = [];
      let newPolygon = [];
      let polygon = {};
      if (this.sample.soilArea.areaType == "SOLENA") {
        if (
          this.sample.soilArea.polygon &&
          this.sample.soilArea.polygon.length > 0
        ) {
          this.sample.soilArea.polygon.map((elem) => {
            let temp = [...newPolygon];
            temp.push(elem.lat);
            temp.push(elem.lng);
            temp.push(0);

            newPolygon = [...temp];
          });

          let color = statusColor[this.sample.soilArea.status];
          // create polygon
          let geoPolygon = new H.map.Polygon(
            new H.geo.Polygon(new H.geo.LineString([...newPolygon])),
            {
              style: {
                fillColor: color,
                lineWidth: 1,
                strokeColor: "#000",
              },
            }
          );

          geoPolygon.setData(this.sample.soilArea);
          objects.push(geoPolygon);
          polygon = geoPolygon;
          newPolygon = [];
        } else {
          let color = statusColor[this.sample.soilArea.status];

          let geoCircle = new H.map.Circle(
            // The central point of the circle
            {
              lat: this.sample.soilArea.location.lat,
              lng: this.sample.soilArea.location.lng,
            },
            // The radius of the circle in meters
            100,
            {
              style: {
                strokeColor: "#000", // Color of the perimeter
                lineWidth: 1,
                fillColor: color, // Color of the circle
              },
            }
          );

          geoCircle.setData(this.sample.soilArea);
          objects.push(geoCircle);
          polygon = geoCircle;
          newPolygon = [];
        }

        let container = new H.map.Group({
          objects,
        });
        // container.addEventListener("tap", this.polygonTap);
        this.map.addObject(container);
        this.addMarkers();

        this.map.getViewModel().setLookAtData({
          bounds: polygon.getBoundingBox(),
        });
      } else if (this.sample.soilArea.areaType == "EXPERIMENTAL") {
        let container = new H.map.Group({
          objects,
        });
        // container.addEventListener("tap", this.polygonTap);
        this.map.addObject(container);
        this.addMarkers();
      }
    },

    // add markers to selected area
    addMarkers() {
      if (this.markerSubSamples.length > 0) {
        // this.map.removeObjects(this.markerSubSamples);
        this.markerSubSamples = [];
      }

      this.mapIcon = new H.map.Icon(this.markerIcon.imgFlag, {
        size: {
          w: 40,
          h: 41,
        },
      });

      let mapIconX = new H.map.Icon(this.markerIcon.imgX, {
        size: {
          w: 30,
          h: 31,
        },
      });

      if (this.sample.soilArea.targetLocations.length > 0) {
        let markers = [];
        for (let i = 0; i < this.sample.soilArea.targetLocations.length; i++) {
          let marker = new H.map.Marker(
            {
              lat: this.sample.soilArea.targetLocations[i].lat,
              lng: this.sample.soilArea.targetLocations[i].lng,
            },
            {
              icon: mapIconX,
            }
          );

          marker.setData(this.sample.soilArea);
          // this.markerSubSamples.push(marker);

          markers.push(marker);
        }
        // add markers to the group
        this.groupMarkers = new H.map.Group();
        this.groupMarkers.addObjects([...markers]);
        // this.groupMarkers.addEventListener("tap", this.markerTap);
        this.map.addObject(this.groupMarkers);
      }

      if (this.sample.subSamples.length > 0) {
        for (let i = 0; i < this.sample.subSamples.length; i++) {
          let marker = new H.map.Marker(
            {
              lat: this.sample.subSamples[i].location.lat,
              lng: this.sample.subSamples[i].location.lng,
            },
            {
              icon: this.mapIcon,
            }
          );
          marker.setData(this.sample.subSamples[i]._id);
          this.markerSubSamples.push(marker);
        }
        // add markers to the group
        this.groupMarkers = new H.map.Group();
        this.groupMarkers.addObjects([...this.markerSubSamples]);
        this.groupMarkers.addEventListener("tap", this.markerTap);
        this.map.addObject(this.groupMarkers);
      }

      if (this.sample.subSamples.length > 0) {
        let markers = [];
        for (let i = 0; i < this.sample.subSamples.length; i++) {
          var html = document.createElement("div"),
            divText = document.createElement("div");

          var label =
            typeof this.sample.subSamples[i].description === "undefined"
              ? ""
              : this.sample.subSamples[i].description;
          var description = "";
          if (label.length > 10) {
            description = label.substring(0, 10);
            description += "...";
          } else {
            description = label;
          }

          divText.innerHTML = description;
          html.appendChild(divText);

          this.mapIcon = new H.map.DomIcon(html);

          let marker = new H.map.DomMarker(
            {
              lat: this.sample.subSamples[i].location.lat,
              lng: this.sample.subSamples[i].location.lng,
            },
            {
              icon: this.mapIcon,
            }
          );
          markers.push(marker);
        }
        // add markers to the group
        this.groupMarkers = new H.map.Group();
        this.groupMarkers.addObjects([...markers]);
        // this.groupMarkers.addEventListener("tap", this.markerTap);
        this.map.addObject(this.groupMarkers);
      }
    },

    markerTap(event) {
      this.SET_SHOW_ALL(true);
      if (this.sample.subSamples.status === "IN_PROGRESS") {
        for (let i = 0; i < this.sample.subSamples.length; i++) {
          if (event.target.getData() === this.sample.subSamples[i]._id) {
            this.navigation = i;
            break;
          }
        }
      } else {
        for (let i = 0; i < this.sample.subSamples.length; i++) {
          if (event.target.getData() === this.sample.subSamples[i]._id) {
            this.navigation = i + 1;
            break;
          }
        }
      }
    },
    openDialog(description) {
      this.dialog = !this.dialog;
      this.description = description;
    },
    closeSheet() {
      this.SET_SHOW_ALL(false);
    },
    getSymptomatology(item) {
      if (
        this.sample &&
        this.sample.cropCycle &&
        this.sample.cropCycle.crop &&
        this.sample.cropCycle.crop.cropName.length != 0
      ) {
        switch (this.sample.cropCycle.crop.cropName) {
          case "avocado":
            return this.translations.symp_avocado[item] || item;

          case "blackberry":
            return this.translations.symp_blackberry_raspberry[item] || item;

          case "raspberry":
            return this.translations.symp_blackberry_raspberry[item] || item;

          case "strawberry":
            return this.translations.symp_strawberry[item] || item;

          case "blueberry":
            return this.translations.symp_blueberry[item] || item;

          case "orange":
            return this.translations.symp_orange[item] || item;

          case "chillyPepper":
            return (
              this.translations.symp_chili_peppers_cucumber_tomato[item] || item
            );

          case "cucumber":
            return (
              this.translations.symp_chili_peppers_cucumber_tomato[item] || item
            );

          case "tomato":
            return (
              this.translations.symp_chili_peppers_cucumber_tomato[item] || item
            );

          case "potato":
            return this.translations.symp_potato[item] || item;

          case "asparagus":
            return this.translations.symp_asparagus[item] || item;

          default:
            return this.translations.symp[item] || item;
        }
      }
    },
    async downloadImg(url) {
      try {
        this.isLoading = true;
        let payload = {
          url: url,
        };

        let response = await this.getImg(payload);

        // Crear un enlace temporal
        const link = document.createElement("a");
        link.href = "data:image/jpeg;base64," + response.image; // Agrega la URL de la imagen en base64
        link.download = response.name; // Establece el nombre de archivo

        // Simular clic en el enlace
        link.click();
      } catch (error) {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
      this.isLoading = false;
    },
    getKind(kind) {
      switch (kind) {
        case "PLAGUE":
          return this.translations.plague;

        case "DISEASE":
          return this.translations.disease;

        // case "WEED":
        //   return this.translations.weed;

        // case "NUTRITION":
        //   return this.translations.nutrition;

        default:
          return kind;
      }
    },
    getIssue(kind, issue) {
      let diseaseListAvocado = [
        {
          label: this.translations.avocado_disease_list.unknown,
          value: "unknown",
        },
        {
          label: this.translations.avocado_disease_list.damping_off,
          value: "Pythium sp.",
        },
        {
          label: this.translations.avocado_disease_list.anthracnose_classic,
          value: "Colletotrichum gloeosporioides",
        },
        {
          label: this.translations.avocado_disease_list.anthracnose_boninense,
          value: "Colletotrichum boninense",
        },
        {
          label: this.translations.avocado_disease_list.bacterial_canker,
          value: "Xanthomonas sp.",
        },
        {
          label: this.translations.avocado_disease_list.sooty_mold,
          value: "Capnodium sp.",
        },
        {
          label: this.translations.avocado_disease_list.angular_leaf_spot,
          value: "Cercospora purpurea",
        },
        {
          label: this.translations.avocado_disease_list.tar_spot,
          value: "Phyllachora gratissima",
        },
        {
          label: this.translations.avocado_disease_list.leaf_spot_septoria,
          value: "Septoria sp.",
        },
        {
          label: this.translations.avocado_disease_list.black_spot,
          value: "Diplocarpon rosae",
        },
        {
          label: this.translations.avocado_disease_list.fusarium_wilt,
          value: "Fusarium sp.",
        },
        {
          label: this.translations.avocado_disease_list.root_rot_rhizoctonia,
          value: "Rhizoctonia solani",
        },
        {
          label: this.translations.avocado_disease_list.fruit_rot_diplodia,
          value: "Diplodia sp.",
        },
        {
          label: this.translations.avocado_disease_list.fruit_rot_dothiorella,
          value: "Dothiorella sp.",
        },
        {
          label: this.translations.avocado_disease_list.scab,
          value: "Sphaceloma perseae",
        },
        {
          label: this.translations.avocado_disease_list.avocado_root_rot,
          value: "Phytophthora cinnamomi",
        },
        {
          label: this.translations.avocado_disease_list.botrytis_cinerea,
          value: "Botrytis cinerea",
        },
        {
          label: this.translations.avocado_disease_list.cladosporium_fulvum,
          value: "Cladosporium fulvum",
        },
        {
          label: this.translations.avocado_disease_list.colletotrichum_acutatum,
          value: "Colletotrichum acutatum",
        },
        {
          label: this.translations.avocado_disease_list.glomerella_cingulata,
          value: "Glomerella cingulata",
        },
        {
          label: this.translations.avocado_disease_list.monilia_spp,
          value: "Monilia spp.",
        },
        {
          label: this.translations.avocado_disease_list
            .mycosphaerella_fragariae,
          value: "Mycosphaerella fragariae",
        },
        {
          label: this.translations.avocado_disease_list.peronospora_rubi,
          value: "Peronospora rubi",
        },
        {
          label: this.translations.avocado_disease_list.other,
          value: "other",
        },
      ];

      let plagueListAvocado = [
        {
          label: this.translations.avocado_plague_list.unknown,
          value: "unknown",
        },
        {
          label: this.translations.avocado_plague_list.oligonychus_yothersi,
          value: "Oligonychus yothersi",
        },
        {
          label: this.translations.avocado_plague_list.oligonychus_perseae,
          value: "Oligonychus perseae",
        },
        {
          label: this.translations.avocado_plague_list.oligonychus_punicae,
          value: "Oligonychus punicae",
        },
        {
          label: this.translations.avocado_plague_list.oligonychus_mexicanus,
          value: "Oligonychus mexicanus",
        },
        {
          label: this.translations.avocado_plague_list.copturus_aguacatae,
          value: "Copturus aguacatae",
        },
        {
          label: this.translations.avocado_plague_list.heilipus_lauri,
          value: "Heilipus lauri",
        },
        {
          label: this.translations.avocado_plague_list.conotrachelus_aguacatae,
          value: "Conotrachelus aguacatae",
        },
        {
          label: this.translations.avocado_plague_list.idona_minuenda,
          value: "Idona minuenda",
        },
        {
          label: this.translations.avocado_plague_list.empoasca_abrupta,
          value: "Empoasca abrupta",
        },
        {
          label: this.translations.avocado_plague_list.hemiberlesia_lataniae,
          value: "Hemiberlesia lataniae",
        },
        {
          label: this.translations.avocado_plague_list.pyrrhopyge_chalybea,
          value: "Pyrrhopyge chalybea",
        },
        {
          label: this.translations.avocado_plague_list.gonodonta_pyrgo,
          value: "Gonodonta pyrgo",
        },
        {
          label: this.translations.avocado_plague_list.sabulodes_aegrotata,
          value: "Sabulodes aegrotata",
        },
        {
          label: this.translations.avocado_plague_list.copaxa_multifenestrata,
          value: "Copaxa multifenestrata",
        },
        {
          label: this.translations.avocado_plague_list.amorbia_cuneana,
          value: "Amorbia cuneana",
        },
        {
          label: this.translations.avocado_plague_list.gracillaria_spp,
          value: "Gracillaria spp.",
        },
        {
          label: this.translations.avocado_plague_list.aleurodes_sp,
          value: "Aleurodes sp.",
        },
        {
          label: this.translations.avocado_plague_list.tetraleurodes_perseae,
          value: "Tetraleurodes perseae",
        },
        {
          label: this.translations.avocado_plague_list.aleurodicus_dugesii,
          value: "Aleurodicus dugesii",
        },
        {
          label: this.translations.avocado_plague_list.bemisia_argentifolii,
          value: "Bemisia argentifolii",
        },
        {
          label: this.translations.avocado_plague_list.paraleyrodes_perseae,
          value: "Paraleyrodes perseae",
        },
        {
          label: this.translations.avocado_plague_list.aethalion_quadratum,
          value: "Aethalion quadratum",
        },
        {
          label: this.translations.avocado_plague_list.stenoma_catenifer,
          value: "Stenoma catenifer",
        },
        {
          label: this.translations.avocado_plague_list.metcalfiella_monograma,
          value: "Metcalfiella monograma",
        },
        {
          label: this.translations.avocado_plague_list.trioza_anceps,
          value: "Trioza anceps",
        },
        {
          label: this.translations.avocado_plague_list.neohydatothrips_signifer,
          value: "Neohydatothrips signifer",
        },
        {
          label: this.translations.avocado_plague_list
            .pseudophilothrips_perseae,
          value: "Pseudophilothrips perseae",
        },
        {
          label: this.translations.avocado_plague_list
            .heliothrips_haemorrhoidalis,
          value: "Heliothrips haemorrhoidalis",
        },
        {
          label: this.translations.avocado_plague_list.scirtothrips_perseae,
          value: "Scirtothrips perseae",
        },
        {
          label: this.translations.avocado_plague_list.frankliniella_bruneri,
          value: "Frankliniella bruneri",
        },
        {
          label: this.translations.avocado_plague_list
            .frankliniella_occidentalis,
          value: "Frankliniella occidentalis",
        },
        {
          label: this.translations.avocado_plague_list.tetranychus_urticae,
          value: "Tetranychus urticae",
        },
        {
          label: this.translations.avocado_plague_list.liriomyza_sp,
          value: "Liriomyza sp.",
        },
        {
          label: this.translations.avocado_plague_list.tuta_absoluta,
          value: "Tuta absoluta",
        },
        {
          label: this.translations.avocado_plague_list.aphis_sp_green,
          value: "Aphis sp.",
        },
        {
          label: this.translations.avocado_plague_list.diaphorina_citri,
          value: "Diaphorina citri",
        },
        {
          label: this.translations.avocado_plague_list.spodoptera_frugiperda,
          value: "Spodoptera frugiperda",
        },
        {
          label: this.translations.avocado_plague_list.keiferia_lycopersicella,
          value: "Keiferia lycopersicella",
        },
        {
          label: this.translations.avocado_plague_list.helicoverpa_zea,
          value: "Helicoverpa zea",
        },
        {
          label: this.translations.avocado_plague_list.heliothis_virescens,
          value: "Heliothis virescens",
        },
        {
          label: this.translations.avocado_plague_list.trichoplusia_ni,
          value: "Trichoplusia ni",
        },
        {
          label: this.translations.avocado_plague_list.manduca_quinquemaculata,
          value: "Manduca quinquemaculata",
        },
        {
          label: this.translations.avocado_plague_list.spodoptera_exigua,
          value: "Spodoptera exigua",
        },
        {
          label: this.translations.avocado_plague_list.liriomyza_spp,
          value: "Liriomyza spp",
        },
        {
          label: this.translations.avocado_plague_list.cydia_pomonella,
          value: "Cydia pomonella",
        },
        {
          label: this.translations.avocado_plague_list.phthorimaea_operculella,
          value: "Phthorimaea operculella",
        },
        {
          label: this.translations.avocado_plague_list.heliothis_zea,
          value: "Heliothis zea",
        },
        {
          label: this.translations.avocado_plague_list.pectinophora_gossypiella,
          value: "Pectinophora gossypiella",
        },
        {
          label: this.translations.avocado_plague_list.bucculatrix_thurberiella,
          value: "Bucculatrix thurberiella",
        },
        {
          label: this.translations.avocado_plague_list.estigmene_acrea,
          value: "Estigmene acrea",
        },
        {
          label: this.translations.avocado_plague_list.copitarsia_consueta,
          value: "Copitarsia consueta",
        },
        {
          label: this.translations.avocado_plague_list.plutella_xylostella,
          value: "Plutella xylostella",
        },
        {
          label: this.translations.avocado_plague_list.liriomyza_munda,
          value: "Liriomyza munda",
        },
        {
          label: this.translations.avocado_plague_list.manduca_sexta,
          value: "Manduca sexta",
        },
        {
          label: this.translations.avocado_plague_list.diatraea_grandiosella,
          value: "Diatraea grandiosella",
        },
        {
          label: this.translations.avocado_plague_list.carpocapsa_pomonella,
          value: "Carpocapsa pomonella",
        },
        {
          label: this.translations.avocado_plague_list.aeneolamia_contigua,
          value: "Aeneolamia contigua",
        },
        {
          label: this.translations.avocado_plague_list.other,
          value: "other",
        },
      ];

      // let weedsListAvocado = [
      //   {
      //     label: this.translations.avocado_weeds_list.chenopodium_album,
      //     value: "Chenopodium album",
      //   },
      //   {
      //     label: this.translations.avocado_weeds_list.equisetum_spp,
      //     value: "Equisetum spp.",
      //   },
      //   {
      //     label: this.translations.avocado_weeds_list.eleusine_indica,
      //     value: "Eleusine indica",
      //   },
      //   {
      //     label: this.translations.avocado_weeds_list.convolvulus_arvensis,
      //     value: "Convolvulus arvensis",
      //   },
      //   {
      //     label: this.translations.avocado_weeds_list.euphorbia_prostrata,
      //     value: "Euphorbia prostrata",
      //   },
      //   {
      //     label: this.translations.avocado_weeds_list.rumex_crispus,
      //     value: "Rumex crispus",
      //   },
      //   {
      //     label: this.translations.avocado_weeds_list.sorghum_halepense,
      //     value: "Sorghum halepense",
      //   },
      //   {
      //     label: this.translations.avocado_weeds_list.setaria_verticillata,
      //     value: "Setaria verticillata",
      //   },
      //   {
      //     label: this.translations.avocado_weeds_list.cyperus_rotundus,
      //     value: "Cyperus rotundus",
      //   },
      //   {
      //     label: this.translations.avocado_weeds_list.other,
      //     value: "other",
      //   },
      // ];

      // let nutritionListAvocado = [
      //   {
      //     label: this.translations.avocado_nutrition.nitrogen,
      //     value: "N",
      //   },
      //   {
      //     label: this.translations.avocado_nutrition.zinc,
      //     value: "Zn",
      //   },
      //   {
      //     label: this.translations.avocado_nutrition.iron,
      //     value: "Fe",
      //   },
      //   {
      //     label: this.translations.avocado_nutrition.potassium,
      //     value: "K",
      //   },
      //   {
      //     label: this.translations.avocado_nutrition.boro,
      //     value: "B",
      //   },
      //   {
      //     label: this.translations.avocado_nutrition.other,
      //     value: "other",
      //   },
      // ];

      if (kind === "DISEASE") {
        let itemFound = diseaseListAvocado.find((item) => item.value == issue);
        return itemFound ? itemFound.label : issue;
      } else if (kind === "PLAGUE") {
        let itemFound = plagueListAvocado.find((item) => item.value == issue);
        return itemFound ? itemFound.label : issue;
        // } else if (kind === "WEED") {
        //   let itemFound = weedsListAvocado.find((item) => item.value == issue);
        //   return itemFound ? itemFound.label : issue;
        // } else if (kind === "NUTRITION") {
        //   let itemFound = nutritionListAvocado.find(
        //     (item) => item.value == issue
        //   );
        //   return itemFound ? itemFound.label : issue;
      } else {
        return issue;
      }
    },
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("samples", ["sample_selected", "isShowAll"]),
  },
  watch: {
    isShowAll(value) {
      this.sheet = value;
    },
  },
};
</script>

<style scoped>
.here-map__container {
  width: auto;
  height: 72vh;
  margin: 10px;
  padding-bottom: 8px;
}

.some {
  position: relative;
  bottom: 0;
  right: 0;
}

/* div.v-sheet {
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
} */

.button-container {
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
}

.button-item {
  margin-right: 10px;
}

@media (max-width: 600px) {
  .button-container {
    flex-direction: column;
    align-items: flex-end;
  }

  .button-item {
    margin-bottom: 10px;
  }
}
</style>
